import React, { useEffect } from 'react'
import Navbar from "@/components/Navbar/Navbar";
import Sidebar from "@/components/Sidebar";
import { Toaster } from "sonner";
// import useTheme from "@/hooks/stores/useTheme";
// import ThemeToggle from "@/components/ThemToggle";
import useAuth from "@/hooks/stores/useAuth";
import { Outlet } from 'react-router-dom';
import Footer from '@/components/Footer';
import { useLocation } from 'react-router-dom';


export const DashboardLayout = () => {

  const { isAuthenticated, userRole } = useAuth();
  const location = useLocation();
  // const { theme } = useTheme();
  
  useEffect(() => {
    const removeToasterStyles = () => {
      const toasterElement = document.getElementById('_rht_toaster');
      if (toasterElement) {
        toasterElement.style.removeProperty('z-index');
        toasterElement.style.removeProperty('inset');
      }
    };

    // Initial removal
    removeToasterStyles();

    // Create an observer to watch for changes
    const observer = new MutationObserver(removeToasterStyles);
    
    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Cleanup observer on component unmount
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-[90.5vh] bg-background text-foreground">
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#F16745",
            color: "#fff",
            border: "none",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            padding: "16px",
            fontSize: "14px",
          },
        }}
      />
      {isAuthenticated ? (
        <div className="flex">
          {/* Sidebar - Only show for non-user roles */}
          {userRole?.toLowerCase() !== "user" && <Sidebar />}

          {/* Main Content */}
          <div className={`flex-1 min-h-screen ${
            userRole?.toLowerCase() === "user" ? 'bg-[#F1EBDB]' : 
            userRole?.toLowerCase() === "legal advisor" ? 'bg-[#F1EBDB]' : ''
          }`}>
            <Navbar />
            <main 
              className={`pt-10  ${
                userRole?.toLowerCase() === "user" 
                  ? '' 
                  : 'lg:ml-[300px]'
              } ${
                userRole?.toLowerCase() === "legal advisor" ? 'bg-white' : ''
              }`}
            >
              <div className=" mx-auto">
                <Outlet />
              </div>
            </main>
          </div>
        </div>
      ) : (
        <main className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className=" mx-auto">
            <Outlet />
          </div>
        </main>
      )}
      {/* <ThemeToggle /> */}
      <div className="lg:ml-[300px]">
        {(!['/form'].includes(location.pathname) || 
          (location.pathname === '/' && ['admin', 'legal advisor', 'head of department'].includes(userRole?.toLowerCase()))) && 
         ['admin', 'legal advisor', 'head of department'].includes(userRole?.toLowerCase()) && 
         <Footer/>}
      </div>  
    </div>
    
  )
}
